import { GetterTree } from 'vuex';

import {
  PlansStateI,
} from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<PlansStateI, RootStateI> = {
};
